module.exports = __webpack_public_path__ + "img/jiandantixian.a56b18b9.png";